import { useTranslation } from 'react-i18next';

export const keyPrefix = 'sortPermissionTags';
export const useSortPermissionTagsTranslation = () => useTranslation('entities', { keyPrefix });

export const ruRu = (__LOCALE_RU__ ? ({
  [keyPrefix]: {
    permission_tag_asc: 'По названию (от А до Я)',
    permission_tag_desc: 'По названию (от Я до А)',
    create_time_desc: 'По дате создания (сначала новые)',
    create_time_asc: 'По дате создания (сначала старые)',
  },
}) : {}) as Record<string, unknown>;

export const en = (__LOCALE_EN__ ? ({
  [keyPrefix]: {
    permission_tag_asc: 'By name (A to Z)',
    permission_tag_desc: 'By name (Z to A)',
    create_time_desc: 'By creation date (newest first)',
    create_time_asc: 'By creation date (oldest first)',
  },
}) : {}) as Record<string, unknown>;

export const esEs = (__LOCALE_ESES__ ? ({
  [keyPrefix]: {
    permission_tag_asc: 'Por nombre (de la A a la Z)',
    permission_tag_desc: 'Por nombre (de la Z a la A)',
    create_time_desc: 'Por fecha de creación (primero los nuevos)',
    create_time_asc: 'Por fecha de creación (primero los antiguos)',
  },
}) : {}) as Record<string, unknown>;

export const ptBr = (__LOCALE_PTBR__ ? ({
  [keyPrefix]: {
    permission_tag_asc: 'Por nome (de A a Z)',
    permission_tag_desc: 'Por nome (de Z a A)',
    create_time_desc: 'Por data de criação (mais novos primeiro)',
    create_time_asc: 'Por data de criação (mais antigos primeiro)',
  },
}) : {}) as Record<string, unknown>;
